<tbody>
  <tr>
    <td style="vertical-align: top; border: groove;">

      <div style="position: relative;">
        <img class="schematicImage" [src]="getImage(SchematicImage)">


        <i class="material-icons button__icon component-dot2" style="line-height: 0;" matTooltip={{ObsName}}
          [class.red-eval]="1" [style]="getPosition(ObsPointX, ObsPointY)"> lens</i>

      </div>

      <div>
        <div class="input-container">
          <span class="label" style="width: 104px;">Inspection Type</span>
          <select id="response" [(ngModel)]="selectedInspectionType"
            style="width: 300px; min-width: 300px;font-size: 12px;" (change)="ChangeInspectionType()" class="get-Input">
            <option value="4">Disassembly Inspection </option>
            <option value="6">Progress Reporting Inspection</option>
          </select>

        </div>
      </div>

      <ng-container *ngIf="selectedInspectionType==4 && DissAssemblyInspectionInfo!=null">


        <ng-container>

          <div style="margin-top: 1%;">

            <div style="margin-left: 9px;">
              <div style="    display: flex; flex-direction: column;justify-content: space-between;">
                <span style="font-size: 12px;"> <b>Obervation Point:</b> {{DissAssemblyInspectionInfo.ObsName}}</span>
                <span style="font-size: 12px;"><b>Question:</b> {{DissAssemblyInspectionInfo.obsQuestion}}</span>
                <!-- <i  *ngIf="DissAssemblyInspectionInfo.obsQuestion!=null" class="material-icons button__icon" style="font-size: 32px; vertical-align: middle;cursor: pointer;"  (click)="OpenInstructions(selectedObservationPoint.ObservationPointQuestionInstruction)">build_circle</i> -->

              </div>
              <ng-container *ngIf="DissAssemblyInspectionInfo.obsTypeID!=3 && DissAssemblyInspectionInfo.obsTypeID!=4 ">

                <div style="margin-top: 1%;"
                  *ngIf="DissAssemblyInspectionInfo.obsTypeID!=3  && DissAssemblyInspectionInfo.obsTypeID!=4">
                  <span style="font-size: 12px;">Reading Number</span>
                  <select (change)="ChangeReadingNum($event)" [(ngModel)]="ReadingNumber"
                    style="width: 64px;margin-left: 4%; min-width: 64px;font-size: 12px;" class="get-Input">
                    <option *ngFor="let  point of DissAssemblyInspectionInfo.ObsMeasurements"
                      value={{point.ReadingNumber}}>{{point.ReadingNumber}}</option>
                  </select>
                  <select (change)="ChangeUnitType($event)" [(ngModel)]="UoM"
                    style="width: 88px;min-width: 88px;font-size: 12px;;" class="get-Input">
                    <option value="1">MM</option>
                    <option value="2">INCH</option>
                  </select>
                  <input type="number" style="width: 50%;" [(ngModel)]="measurement"
                    style="    max-width: 165px;min-width: 165px;font-size: 12px;" class="get-Input"
                    (change)="UpdateMeasurement($event)" placeholder="Measurement">
                </div>
              </ng-container>
            </div>


            <div style="margin-top: 1%;" *ngIf="DissAssemblyInspectionInfo.obsTypeID==3">
              <span style="font-size: 12px;">Select Evaluation</span>
              <select (change)="SelectEvaluation($event)" [(ngModel)]="eval" style="margin-left: 7%;font-size: 12px;"
                class="get-Input">
                <option value="1">A</option>
                <option value="2">B</option>
                <option value="3">C</option>
                <option value="4">X</option>
              </select>
            </div>

            <div style="margin-top: 1%;" *ngIf="DissAssemblyInspectionInfo.obsTypeID==4">
              <span style="font-size: 12px;">Select Selection</span>
              <select (change)="SelectEvaluation($event)" [(ngModel)]="eval" style="margin-left: 7%;font-size: 12px;"
                class="get-Input">
                <option value="1">Accepted</option>
                <option value="2">Monitor</option>
                <option value="4">Not Accepted</option>
              </select>
            </div>
          </div>

          <div class="input-container" style="margin-top: 1%;">
            <span class="label" style="width: 178px;font-size: 12px;">Inspection Comment</span>
            <textarea rows="4" maxlength="256" style="padding: 0px;font-size: 12px;    margin-left: -18px;" class="textAreaComment"
              placeholder="Comment" [(ngModel)]="DissAssemblyInspectionInfo.Comment"></textarea>
          </div>

          <ng-container>

            <span class="panel__header__title" style="font-size: 12px;"><b>Images</b></span>
            <div class="margin-bottom-24" style="overflow-x: auto; white-space: nowrap;max-width: 500px; ">
              <input hidden type='file' (change)="onSelectPhoto($event, fq)" #uploadImage>

              <ng-container>
                <div class="add-new-schematic" (click)="uploadImage.click()"
                  style="float: left; margin-right: 1%; cursor: pointer;" matTooltip="Click to upload a image">
                  <i class="material-icons add-new-schematic__icon">add_box</i>
                  <div class="add-new-schematic__text" style="font-size: 12px;">Add Image</div>
                </div>

                <ng-container *ngIf="DissAssemblyInspectionInfo.ImageList!=null">
                  <ng-container *ngFor="let img of DissAssemblyInspectionInfo.ImageList">
                    <img [src]="getImage(img)" class="selection__image" (click)="openUploadEditImageDisAssemble(img)"
                      style="width: 40px;     cursor: pointer;" />

                    <mat-icon style="margin-left: 14px; cursor: pointer;" (click)="deleteimageDisAssembly(img)">delete
                    </mat-icon>
                  </ng-container>
                </ng-container>


                <div id="ulSchematics" class="selection-container">

                </div>
              </ng-container>
            </div>
            <!--end new code-->
          </ng-container>
        </ng-container>

      </ng-container>
      <ng-container *ngIf="selectedInspectionType==6 && ProgressReportingInfo!=null">
        <div class="input-container" style="margin-top: 2%;">
          <span class="label" style="width: 178px;font-size: 12px;">Inspection Comment</span>
          <textarea rows="4" maxlength="256" style="padding: 0px;font-size: 12px;" class="textAreaComment"
            placeholder="Comment" [(ngModel)]="ProgressReportingInfo.Comment"></textarea>
        </div>

        <div class="input-container">
          <span class="label" style="font-size: 12px;">% Complete</span>
          <input size="40" type="text" style="max-width: 160px;font-size: 12px;"
            [(ngModel)]="ProgressReportingInfo.completePercentage" class="get-Input" />
        </div>

        <div>
          <span style="font-size: 12px;">
            <b>Last Entry :</b> {{ProgressReportingInfo.Inspector}} - {{ProgressReportingInfo.RecordDate}}
          </span>
        </div>
        <ng-container>

          <span class="panel__header__title" style="font-size: 12px;"><b>Images</b></span>
          <div style="overflow-x: auto; white-space: nowrap;max-width: 500px; ">
            <input hidden type='file' (change)="onSelectPhoto($event, fq)" #uploadImage>

            <ng-container>
              <div class="add-new-schematic" (click)="uploadImage.click()"
                style="float: left; margin-right: 1%; cursor: pointer;" matTooltip="Click to upload a image">
                <i class="material-icons add-new-schematic__icon">add_box</i>
                <div class="add-new-schematic__text" style="font-size: 12px;">Add Image</div>
              </div>

              <ng-container *ngIf="ProgressReportingInfo.ImageList!=null">
                <ng-container *ngFor="let img of ProgressReportingInfo.ImageList">
                  <img [src]="getImage(img)" class="selection__image" (click)="openUploadEditImageProgress(img)"
                    style="width: 40px;     cursor: pointer;" />

                  <mat-icon style="margin-left: 14px; cursor: pointer;" (click)="deleteimageProgress(img)">delete
                  </mat-icon>
                </ng-container>
              </ng-container>


              <div id="ulSchematics" class="selection-container">

              </div>
            </ng-container>
          </div>
          <!--end new code-->
        </ng-container>
      </ng-container>
      <span style="color: red;font-size: 12px;" *ngIf="showError==true">Need Approval to Start the Progress Reporting
        Inspection</span>
      <div class="ttmodal__footer" style="float: right;margin-top: 0%;">
        <a class="button margin-right-8" (click)="onCloseClick()"><span class="button__text"
            style="font-size: 12px;">Cancel</span></a>
        <a class="button button--primary" (click)="saveChangesInspection()"><span class="button__text"
            style="font-size: 12px;">Update</span></a>
      </div>

    <!--Inspection Histroy-->
      <div class="ttmodal__footer" style="margin-top: 15%;overflow-y: auto;    max-height: 217px;">
        <span style="font-size: 12px;"><u>Inspection History</u></span>
        <div *ngFor="let InsType of arrInspectionTypes"
          style="display: flex; flex-direction: column; flex: 1;align-items: baseline;">
          <div class="header__title-container">
            <span class="panel__header__title" style="font-size: 12px;"><b>{{InsType.FECRInspectionType}}</b></span>
          </div>

          <div style="display: flex;margin-top: 20px;width: 100%;">

            <span style="align-items: center;display: flex;margin-right: 20px;width: 100px;font-size: 12px;">Images</span>
            <ng-container *ngFor="let imagesData of InsType.ObservationDetails.ObservationImage">
              <img  class="selection__image"    style="width: 40px;" [src]="getImage(imagesData.image)" />
            </ng-container>

            <ng-container
              *ngIf="!InsType.ObservationDetails.ObservationImage ||InsType.ObservationDetails.ObservationImage.length == 0">
              <span class="label" style="font-size: 12px;">No Images Found</span>
            </ng-container>
          </div>

          <div style="display: flex;margin-top: 20px;width: 100%;">

            <span style="align-items: center;display: flex; margin-right: 20px;width: 100px;font-size: 12px;">Comment</span>

            <textarea *ngIf="InsType.ObservationDetails.ObservationComment" class="textAreaComment" rows="2"  maxlength="256" disabled
              placeholder="Observation Point Comment. " style="font-size: 12px;">{{InsType.ObservationDetails.ObservationComment}}</textarea>

            <span *ngIf="!InsType.ObservationDetails.ObservationComment" class="label" style="font-size: 12px;">No Comments Found</span>

          </div>

        </div>

        <div *ngFor="let InsType of arrInspectionTypes" style="display: flex;flex-direction: column;flex: 1; align-items: baseline;">

          <div class="header__title-container">
            <span class="panel__header__title" style="font-size: 12px;"><b>Progress Reporting Inspection</b></span>
          </div>
          <ng-container *ngFor=" let info of InsType.ProgressReportingDetails">
            <div style="display: flex;margin-top: 20px;width: 100%;">

              <span style="align-items: center;display: flex;margin-right: 20px;width: 100px; font-size: 12px;" >Record Details</span>

              <span style="font-size: 12px;">{{info.Inspector}} - {{info.RecordDate}}</span>

            </div>
            <div style="display: flex;margin-top: 20px;width: 100%;">

              <span style="align-items: center;display: flex;margin-right: 20px;width: 100px;font-size: 12px;">Complete Percentage(%)</span>

              <span style="font-size: 12px;">{{info.completePercentage}} %</span>

            </div>
            <div style="display: flex;margin-top: 20px;width: 100%;">

              <span style="align-items: center; display: flex;margin-right: 20px;width: 100px ;font-size: 12px;">Images</span>

              <ng-container *ngFor="let imagesData of info.ImageList">

                <img  class="selection__image"    style="width: 40px;"  [src]="getImage(imagesData)" />
              </ng-container>

              <ng-container *ngIf="info.ImageList == null ||info.ImageList.length == 0">
                <span class="label" style="font-size: 12px;">No Images Found</span>
              </ng-container>


            </div>

            <div style="display: flex;margin-top: 20px;width: 100%;">

              <span style="align-items: center;display: flex;margin-right: 20px;width: 100px;font-size: 12px;">Comment</span>
 
              <textarea *ngIf="info.Comment" rows="2" maxlength="256" disabled class="textAreaComment" style="font-size: 12px;"
                placeholder="Observation Point Comment. ">{{info.Comment}}</textarea>

              <span *ngIf="!info.Comment" style="font-size: 12px;">No Comments Found</span>

            </div>
          </ng-container>


        </div>
      </div>
 <!--End Inspection Histroy-->

    </td>

        <!--Recommendation-->
    <td style="border: groove;vertical-align: top;">
      <div class="ttmodal" style="width: 635px;">
        <div class="ttmodal__header">
          <div style="display: flex; flex-direction: column;">
            <span style="font-size: 15px;">{{CompTypeName}} - {{CompName}} - {{ObsName}}</span>
            <span style="font-size: 14px;">Observation Point Recommendation</span>
          </div>

          <i class="material-icons ttmodal__close-button" (click)="onCloseClick()">close</i>
        </div>
        <div class="ttmodal__body">

          <!-- <div class="input-container">
              <span class="label" style="width: 152px;">Inspection Comment</span>
              <textarea rows="4" maxlength="256"  disabled style="padding: 0px;"
              placeholder="Observation Point Inspection Comment. "  [(ngModel)]="obsInspectionComment"  ></textarea>
            </div> -->

          <div class="input-container">
            <div style="display: flex;flex-direction: row;    display: flex;
              width: 137px;">
              <span class="label" >Repairs/Rebuild</span>
              <span class="label" style="color: crimson;width: 0px;">*</span>
            </div>

            <input type="text"  placeholder="Enter details of action required" [(ngModel)]="obsRecommendation" class="get-Input" style="width: 80%; font-size: 12px;" />
          </div>

          <div class="input-container">
            <span class="label">Hours</span>
            <div style="display: flex;flex-direction: row;">
              <input size="10" type="number" value="0" min="0" style="max-width: 100px;" [(ngModel)]="obsHours"
                class="get-Input" />
              <span class="input-icon">(Hrs)</span>
            </div>
          </div>



          <div class="input-container">
            <span class="label">Repair Costs</span>

            <div style="flex-direction: row;display: flex;flex: 1;justify-content: space-between;">



              <div style="width: 60px;">
                <span style="width: 80px;" class="label">Labour $</span>
                <div style="display: flex;flex-direction: row;">
                  <input type="number" value="0" min="0" size="10" style="max-width: 100px;min-width: 100px;"
                    class="get-Input" [(ngModel)]="obsLabourCost" (change)="OnChangeLabourCost($event.target.value)" />
                  <span class="input-icon">$</span>
                </div>
              </div>

              <div style="width: 60px;">
                <span style="width: 80px;" class="label">Parts $</span>
                <div style="display: flex;flex-direction: row;">
                  <input type="number" value="0" min="0" size="10" style="max-width: 100px;;min-width: 100px;"
                    class="get-Input" [(ngModel)]="obsPartsCost" (change)="OnChangePartsCost($event.target.value)" />
                  <span class="input-icon">$</span>
                </div>
              </div>

              <div style="width: 60px;">
                <span style="width: 80px;" class="label">Misc $</span>
                <div style="display: flex;flex-direction: row;">
                  <input type="number" value="0" min="0" size="10" style="max-width: 100px;;min-width: 100px;"
                    class="get-Input" [(ngModel)]="obsMiscCost" (change)="OnChangeMiscCost($event.target.value)" />
                  <span class="input-icon">$</span>
                </div>

              </div>

              <div style="width: 60px;">
                <span style="width: 80px;" class="label">Total $</span>
                <div style="display: flex;align-items: center;justify-content: center;display: flex;
                align-items: center;
                justify-content: center;
                width: 50px;
                height: 50px;">
                  <span style="width: 80px;display: contents;font-weight: bold;" class="label">{{obsRepairTotal}}</span>
                </div>

                <!-- <input type="number" value="0" min="0" size="10" style="max-width: 100px;"  [(ngModel)]="obsRepairTotal" disabled /> -->
              </div>

            </div>
          </div>

          <div class="input-container">
            <span class="label_" style="width: 144px;font-size: 12px;">Repair Part Numbers</span>
            <input type="text" placeholder="List parts numbers required for rebuild" [(ngModel)]="obsRepairPartsList" 
              class="get-Input" style="width: 80%; font-size: 12px;" />
          </div>
          <div class="input-container">
            <span class="label_"style="width: 144px;font-size: 12px;">Repair Cost Comment</span>
            <input type="text" placeholder="Enter comments about the repair" [(ngModel)]="obsRepairCostComment"
              class="get-Input" style="width: 80%;font-size: 12px;" />
          </div>


          <!-- <div class="input-container">
              <span class="label">% Complete</span>
              <input size="40" type="text" style="max-width: 200px;" [(ngModel)]="ObsCompletePercentage"/>
            </div> -->

          <div class="input-container">
            <span class="label">Approval Required</span>
            <select id="response" [(ngModel)]="AppRequired" style="width: 140px;min-width: 140px;" class="get-Input">
              <option value="1">Yes</option>
              <option value="2">No</option>
            </select>

            <span class="label" style="margin-left: 3%;">Approval Response</span>
            <select id="response" [(ngModel)]="AppResponse" style="width: 140px;min-width: 140px;" class="get-Input">
              <option value="0">Pending</option>
              <option value="1">Yes</option>
              <option value="2">No</option>
            </select>
          </div>

          <!-- <div class="input-container">
              <span class="label">Approval Response</span>
              <select id="response" [(ngModel)]="AppResponse">
                <option value="1">Yes</option>
                <option value="2">No</option>
              </select>
            </div> -->


          <div class="input-container">
            <span class="label_" style="width: 182px;;font-size: 12px;">Approval Comment</span>
            <textarea rows="4" maxlength="256" [(ngModel)]="ApprovalComment" class="textAreaComment" style="font-size: 12px;"
              placeholder="Enter a comment about why the implement status was changed. "></textarea>
          </div>

          <div class="input-container">
            <span class="label_" style="width: 143px;font-size: 12px;">Approval Comment History</span>
            <textarea rows="4" maxlength="256" [(ngModel)]="ApprovalCommentHistory" style="width: 80%;font-size: 12px;" disabled
              class="textAreaComment"
              placeholder="Enter a comment about why the implement status was changed. "></textarea>
          </div>


          <div class="input-container">
            <span class="label">Status</span>
            <input size="40" type="text" style="max-width: 135px;" [(ngModel)]="obsStatus" disabled class="get-Input" />

            <span class="label" style="    margin-left: 4%;">% Complete</span>
            <input size="40" type="text" style="max-width: 160px;" disabled [(ngModel)]="ObsCompletePercentage"
              class="get-Input" />
          </div>

          <div style="display: flex;" *ngIf="showRequiredError">
            <span class="label" style="color: crimson;">Please update the Required (*) fields.</span>
          </div>

          <div class="ttmodal__footer"style="float: right; margin-top: 0px; margin-bottom: 5px;">
            <a class="button margin-right-8" (click)="onCloseClick()"><span class="button__text">Cancel</span></a>
            <a class="button button--primary" (click)="saveChanges()"><span class="button__text">Update</span></a>
          </div>
        </div>
      </div>
    </td>
  </tr>
</tbody>